import styled from 'styled-components'
import theme from 'styles/theme'
import { themeGet, display } from 'styled-system'
import { Body10 } from 'components/Typography'

import { GatsbyImage } from 'gatsby-plugin-image'

export const ImageWrapper = styled.div`
  position: relative;
  display: inline-block;
  height: 100%;
  width: 100%;

  height: 150vw;
  min-height: 400px;
  max-height: 540px;
  width: 100%;

  ${(props) =>
    props.portraitAsLandscape &&
    `
    min-height: unset;
    height: auto;
  `}

  ${theme.mediaQueries.small} {
    max-height: 768px;
  }
  ${theme.mediaQueries.medium} {
    max-height: 1024px;
    height: 56vw;
  }
`

export const LandscapeImage = styled(GatsbyImage)`
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
`

export const PortraitImage = styled(GatsbyImage)`
  max-width: 580px;
  width: 90%;
  margin: ${theme.space[4]} auto 0 auto;
`

export const FullBleedImage = styled(GatsbyImage)`
  ${display}
`

export const ImageCaption = styled.div`
  padding: 0 ${theme.space[3]};
  max-width: ${theme.containterMaxWidth};
  width: 90%;
  margin: ${theme.space[4]} auto 0;
  display: block;
  ${(props) =>
    props.type === 'portrait' &&
    `
    padding: 0;
    max-width: 580px;
  `}
  ${(props) =>
    props.type === 'landscape' &&
    `
    padding: 0;
    max-width: 1000px;
  `}
`

export const Caption = styled(Body10)`
  color: ${themeGet('colors.sagedark')};
  line-height: 1;
  margin: 0 0 3px;
`

export const Credit = styled(Body10)`
  color: ${themeGet('colors.sagemedium')};
  line-height: 1;
  margin: 0;
`

export default {
  ImageWrapper,
  LandscapeImage,
  PortraitImage,
  FullBleedImage,
  ImageCaption,
  Caption,
  Credit,
}
